import type { GetAllRecipientGroupsResponseType } from 'src/api/generated/touring/types';
import { mapRecipientGroupType } from './helpers';
import type { GetAllRecipientGroupsType } from './types';

export const mapGetAllRecipientGroupsResponseType = (
  api: GetAllRecipientGroupsResponseType
): GetAllRecipientGroupsType => ({
  results: api.data.map(mapRecipientGroupType),
});
